import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8001";
const TOKEN_KEY = 'access_token';

class AuthService {
    /**
     * Authenticate user with the backend
     */
    async login(licenseKey) {
        try {
            const response = await axios.post(`${API_BASE_URL}/auth/login`, {
                license_key: licenseKey
            });

            if (response.data && response.data.access_token) {
                // Store the token in localStorage
                localStorage.setItem(TOKEN_KEY, response.data.access_token);
                return response.data;
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error(error.message || "Failed to login");
        }
    }

    /**
     * Clear token and state
     */
    logout() {
        localStorage.removeItem(TOKEN_KEY);
        // Force a reload to clear application state, or use a router redirect depending on usage context
        window.location.href = "/login";
    }

    /**
     * Retrieve the stored token
     */
    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    }

    /**
     * Check if a token currently exists
     */
    isAuthenticated() {
        return !!this.getToken();
    }
}

// Export a singleton instance
export const authService = new AuthService();
export default authService;
